/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_5_HInputs */

const en_terms_5_h = /** @type {(inputs: Terms_5_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your content`)
};

const id_terms_5_h = /** @type {(inputs: Terms_5_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontenmu`)
};

/**
* | output |
* | --- |
* | "Your content" |
*
* @param {Terms_5_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const terms_5_h = /** @type {((inputs?: Terms_5_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_5_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_terms_5_h(inputs)
	return en_terms_5_h(inputs)
});